// extracted by mini-css-extract-plugin
export default {"ShareModal":"Styles_ShareModal__GGae4","Title":"Styles_Title__quBDF","Paragraph":"Styles_Paragraph__PUzKa"};